const fileUpload = {
  insertNewFile: "Neue Datei einfügen",
  dragYourFileHereOrClickToSelectAFile: "Ziehen Sie Ihre Datei hierher, oder klicken Sie um eine Datei auszuwählen.",
  maxFileSize: "max. Dateigröße",
  uploadFailedPleaseChangeFileAndUploadAgain: "Upload fehlgeschlagen. Bitte Datei ändern und erneut hochladen.",
  theFollowingFileTypesAreAllowed: "Folgende Dateitypen sind erlaubt: ",
  fileUploadedSuccessfully: "Datei erfolgreich hochgeladen.",
  insertedFile: "Eingefügte Datei",
};

export default fileUpload;
